module.exports = __webpack_public_path__ + "default-skin.b257fa9c5ac8c515ac4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lightbox/default-skin.svg
// module id = 209
// module chunks = 2